import { createContext } from 'react';

export type CreateAutoBalanceCtx = {
  showCreateAutoBalanceErrorAlert: boolean,
  createAutoBalanceError: string,
};

const CreateAutoBalanceDialogueContext = createContext<CreateAutoBalanceCtx>({
  showCreateAutoBalanceErrorAlert: false,
  createAutoBalanceError: '',
});

export default CreateAutoBalanceDialogueContext;